
export const constants = () => {
  return {
    PATENT_FOR_STARTUPS: 'Patent For Startups',
    ALL_ABOUT_PATENTS: 'All About Patents',
    TRADEMARK: 'Trademark - Protecting Your Brands',
    UNCATEGORIED: 'Uncategorized',
    carouselResponsive: {
      superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5
      },
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3
      },
      tablet: {
        breakpoint: { max: 1024, min: 600 },
        items: 2
      },
      mobile: {
        breakpoint: { max: 600, min: 0 },
        items: 1
      }
    }
  }
}

export const addSubcriber = async (data) => {
  const response  = await fetch("https://api.trustyip.com/subcribers/add", {
    "method": "POST",
    "headers": {
        "content-type": "application/json",
        "accept": "application/json"
    },
    "body": JSON.stringify(data)
    });

    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
      // throw new Error(message);
      console.log(message);
      return;
    }
  
    const result = await response.json();
    return result;
}

export const todayStr = () => {
  var date = new Date();
  return (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear();
}

export const getMonthName = () => {
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  
  const d = new Date();
  return  monthNames[d.getMonth()];
}

export const getDayOfMonth = () => {
  return new Date().getDate();
}

export const getGTMOffsetStr = () => {
  const d = new Date();
  const diff = d.getTimezoneOffset();

  return `GMT ${diff < 0? '+' : '-'}` + ((-diff) / 60)
}

export const getTimeIn12Hours = () => {
  const d = new Date();
  return d.toLocaleString([], {hour: '2-digit', minute:'2-digit'});
}

export const isValidEmail = (email) =>{
  return /\S+@\S+\.\S+/.test(email);
}

export const addAndRemoveDisabledCls = (eleId) => {
  const ele = document?.getElementById(eleId);
  if (ele) {
    ele.classList.add("disabled");
    // Remove after 3 minutes
    setTimeout(function() {
      const ele = document?.getElementById(eleId);
      if (ele) {
        ele.classList.remove("disabled");
      }
    }, 3 * 60 * 1000);
  }
}

export const validateSubscriberData = (person) => {
  if ('firstName' in person) {
    if (person.firstName.trim() === '') {
      alert('First name is invalid!!!');
      return false;
    }
  }

  //
  if ('lastName' in person) {
    if (person.lastName.trim() === '') {
      alert('Last name is invalid!!!');
      return false;
    }
  }

  //
  if ('name' in person) {
    if (person.name.trim() === '') {
      alert('Name is invalid!!!');
      return false;
    }
  }

  //
  if ('email' in person) {
    if (!isValidEmail(person.email)) {
      alert('Email is invalid!!!');
      return false;
    }
  }

  // The number field has to have 8+ digits
  if ('phone' in person) {
    const phone_trim = person.phone.trim();
    const regex = /[a-zA-Z\s]/g;
    const found = phone_trim.match(regex);
    if ((phone_trim.length < 8) || (found)) {
      alert('The number field has to have 8+ digits');
      return false;
    }
  }

  //
  if ('subject' in person) {
    if (person.subject.trim() === '') {
      alert('Subject is invalid!!!');
      return false;
    }
  }

  // The message has to be 20+ characters.
  if ('message' in person) {
    const mess = person.message.trim().replace(/(\r\n|\n|\r)/gm,"");
    if (mess.length < 20) {
      alert('The message has to be 20+ characters');
      return false;
    }
  }

  return true;
}

export const isSSR = () => typeof window === 'undefined' || !window.document;

export const addExternalScript = (url, callback) => {
  const script = document.createElement("script");
  script.src = url;
  script.async = true;
  if (callback) {
    script.onload = callback;
  }
  document.body.appendChild(script);
};

export function submitFreeConsultationForm(data, message = "") {
  // const formData = new FormData();

  // // Hidden field key/values.
  // formData.append("u", "27"); // Form Get A Free Consultation
  // formData.append("f", "27"); // https://patent.activehosted.com/f/27
  // formData.append("s", null);
  // formData.append("c", "0");
  // formData.append("m", "0");
  // formData.append("act", "sub");
  // formData.append("v", "2");
  // formData.append("or", "76ef4a4281b95723f0229c110ab30268");

  // // Form field key/values.
  // for (const [key, value] of Object.entries(data)) {
  //   let fieldName = key;
  //   switch (key) {
  //     case "name":
  //       fieldName = "fullname";
  //       break;
  //     case "subject":
  //       fieldName = "field[44]";
  //       break;
  //     case "message":
  //       fieldName = "field[45]";
  //       break;
  //     default:
  //       fieldName = key;
  //   }
  //   formData.append(fieldName, value);
  // }

  // fetch(`https://patent.activehosted.com/proc.php`, {
  //   mode: "no-cors",
  //   method: "POST",
  //   body: formData,
  // })
  //   .then((res) => {
  //     if (message) {
  //       alert(message);
  //     }
  //   })
  //   .catch((err) => {
  //     console.log(err);
  //     alert("Something wrong. Please try again later!");
  //   });
}

export const startWithHeaderTag = (content) => {
  // check server side rendering
  // https://github.com/gatsbyjs/gatsby/issues/19487
  if (isSSR()) {
    return;
  }
  // create blog content obj
  var contentObj = document.createElement( 'div' );
  contentObj.innerHTML = content;
  // get first child
  var firstChild = contentObj.firstChild;
  while(firstChild != null && firstChild.nodeType == 3){ // skip TextNodes
    firstChild = firstChild.nextSibling;
  }
  const tagName = firstChild.tagName;
  const headerTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
  if (headerTags.includes(tagName.toLowerCase())) {
    return true;
  } else {
    return false;
  }
}

/**
 * content
 * 
 * @return content
 */
export const removeHtmltagsInsideH2H3Tags = (content) => {
  // check server side rendering
  // https://github.com/gatsbyjs/gatsby/issues/19487
  if (isSSR()) {
    return;
  }
  // create blog content obj
  var contentObj = document.createElement( 'div' );
  contentObj.innerHTML = content;

  // update h2-h3 content text
  var h2Tags = contentObj.getElementsByTagName('h2');
  for(const h2 of h2Tags) {
    h2.innerHTML = h2.innerText || h2.textContent;
  }

  var h3Tags = contentObj.getElementsByTagName('h3');
  for(const h3 of h3Tags) {
    h3.innerHTML = h3.innerText || h3.textContent;
  }

  return contentObj.innerHTML;
}

export const getFirstTextNode = (content) => {
    // check server side rendering
    // https://github.com/gatsbyjs/gatsby/issues/19487
    if (isSSR()) {
      return;
    }
    // create blog content obj
    var contentObj = document.createElement( 'div' );
    contentObj.innerHTML = content;

    var firstText = "Debug";
    // get all p href
    var pTags = contentObj.getElementsByTagName('p');
    for (const p of pTags) {
      firstText = p.innerText || p.textContent || '';
      if (firstText.trim().length > 100) {
        break;
      }
    }
    // console.log(`first text: `, firstText)
    return firstText;
}

export const getActionBoxHtml = () => {
  return `
      <div class="row mb-5">
      <div class="col-md-3 py-3" style="background-color: #EEEEEE">
        <img src="https://wp.patentpc.com/wp-content/uploads/2022/01/bao-2.png" class="h-100 w-100 half-rounded-top" alt="Bao Tran"/>
      </div>
      <div class="col-md-6 py-3" style="background-color: #EEEEEE">
        <h2 style="font-weight: bold;">Need help protecting your invention?</h2>
        <p>Have questions on how to protect your invention?</p>
        <p class="mt-5"><a rel="noreferrer" target="_blank" href="https://calendly.com/powerpatent/powerpatent-meeting" class="btn btn-warning rounded-pill" style="width: 90%; color: white">
        <i class="fa fa-calendar"></i> &nbsp;Book Your Free Consultation
        </a></p>
      </div>
    </div>
  `;
}
export const updatePageContent = (content) => {
    // check server side rendering
    // https://github.com/gatsbyjs/gatsby/issues/19487
    if (isSSR()) {
      return;
    }
    // Remove part
    const WP_URL = '';
    // create blog content obj
    var contentObj = document.createElement( 'div' );
    contentObj.innerHTML = content;

    // get all a href
    var aTags = contentObj.getElementsByTagName('a');
    for (const a of aTags) {
      a.setAttribute("href", a.href.replace(/^.*\/\/[^\/]+/, '/blog'));
    }

    /**
     * Call To Action Content
     */
    const actionBoxHtml = getActionBoxHtml();

    const actionBoxObj = document.createElement( 'div' );
    actionBoxObj.innerHTML = actionBoxHtml;

    var pTags = contentObj.getElementsByTagName('p');
    // Insert before the last p tag
    if (pTags && pTags.length) {
      const lastP = pTags[pTags.length - 1];
      const parentDiv = lastP.parentNode;
      parentDiv.insertBefore(actionBoxObj, lastP);
    }

    // return 
    return contentObj.innerHTML
}

export const getSubTitle = (content) => {
    // check server side rendering
    // https://github.com/gatsbyjs/gatsby/issues/19487
    if (isSSR()) {
      return;
    }

    // create blog content obj
    var contentObj = document.createElement( 'div' );
    contentObj.innerHTML = content;

    // get first h2 for sub title
    var value = '';
    var abposts = contentObj.getElementsByClassName('abpost-category');
    if( abposts && abposts.length) {
      const h2 = abposts[0];
      // get value
      value = h2.innerText;
    }

    return value;
};

export const inventedBy = (subTitle) => {
  if (!subTitle) {
    return subTitle;
  }
  //
  return subTitle.trim().replace('Invented by ', '').replace('invented by ', '');

};

export const updateBlogContent = (content, humanPosts = null, autoPosts = null) => {
    // check server side rendering
    // https://github.com/gatsbyjs/gatsby/issues/19487
    if (isSSR()) {
      return;
    }

  var humanPostContent = '';
  if (humanPosts && humanPosts.length) {
    humanPostContent = '<ul>';
    humanPosts.forEach(p => {
      humanPostContent += `<li>
        <a href="/blog/${p.slug}">${p.title}</a>
      </li>`
    })
    humanPostContent += '</ul>';
  }

  var autoPostContent = "";
  var topic = "";
  var isAutoPosted = false;
  console.log(`autoPosts: `, autoPosts);
  if (autoPosts && autoPosts.length) {
    autoPostContent = "";
    autoPosts.forEach((p) => {
      let tagCats = p.categories.nodes?.length
        ? [].concat(p.categories.nodes.map((a) => a.name))
        : [];
      tagCats = tagCats.concat(
        p.tags.nodes?.length ? p.tags.nodes.map((a) => a.name) : []
      );
      // https://www.notion.so/prohelpnet/simplify-listing-related-blog-b0dfe34478d9492fbd179ea2e3f8d3d3
      // isAutoPosted = isAutoPost(tagCats); // simplify listing related blog
      var abstractContent = "";
      if (topic === "") {
        topic = p.categories.nodes[0].name;
      }
      // get abstract content
      const autoPostContentObj = document.createElement("div");
      autoPostContentObj.innerHTML = p.content;
      const thumbImg =
        p.featuredImage?.node?.mediaItemUrl ||
        autoPostContentObj.querySelector("img")?.src ||
        "https://wp.patentpc.com/wp-content/uploads/2022/10/thumnail_blog_default.png";
      var children = autoPostContentObj.childNodes;
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        // Text Node
        if (child.nodeType === 3) {
          var value = child.nodeValue.replace(/[\n\r]+/g, "");
          if (value.trim() !== "") {
            abstractContent = value;
            break;
          }
        }
      }
      if (abstractContent === "") {
        abstractContent = getFirstTextNode(p.content);
      }
      ///////////////////////////////////////////////////////////////////////////////////////////////////
      if (!isAutoPosted) {
        autoPostContent += `<li>
            <a href="/blog/${p.slug}">${p.title}</a>
          </li>`;
      } else {
        autoPostContent += `
          <div class="mb-3 pb-5">
            <h3>${p.title}</h3>
            <p>This patent came out in ${p.date} and is a great example of ${p.categories.nodes[0].name} patent. 
            We have analyzed it for you. <a class="text-decoration-none" href="/blog/${p.slug}">Click here to read more on our analysis of ${p.title} patents</a> </P>
            <div class="card flex-row border-0 responsive_wrapper">
              <img class="card-img-left  example-card-img-responsive" alt="patentpc" src="${thumbImg}"/>
              <div class="card-body">
                <h4 class="card-title">Abstract of the Patent on ${p.title}</h4>
                <p class="card-text">${abstractContent}</p>
              </div>
            </div>
          </div>
          `;
      }
    }); // For each auto posts
    if (!isAutoPosted) {
      autoPostContent = "<ul>" + autoPostContent + "</ul>";
    }
  }
    /**
     * Disclaimer content
     */
    // const disclaimerHtml = `
    //   <div>
    //     ${
    //       isAutoPosted
    //         ? `<h2>Latest ${topic} Patent Examples Analyzed by PatentPC</h2>`
    //         : "<h2>Related blogs</h2>"
    //     }
    //     ${autoPostContent}
    //   </div>
    //   <div>
    //   <a href="/patentfaqs/" rel="noreferrer" target="_blank">Patent FAQs</a> - <a href="/tmfaqs/" rel="noreferrer" target="_blank">Trademark FAQs</a>
    //   </div>
    //   <p class="h6 mt-2">Check out some  our latest posts on patent filling and patent news:</p>
    //   ${humanPostContent}
    //   <hr>
    //   <p class="disclaimer-text fw-normal">Disclaimer:</p>
    //   <p class="disclaimer-text fw-normal">
    //   The information provided on this blog does not, and is not intended to, constitute legal advice; instead, all information, 
    //   content, and materials available on this site are for general informational purposes only. Information on this website may not 
    //   constitute the most up-to-date legal or other information. This website contains links to other third-party websites. 
    //   Such links are only for the reader, user or browser; we do not recommend or endorse the contents of the third-party sites.
    //   </p>
    //   <p class="disclaimer-text fw-normal">
    //   Readers of this website should contact their attorney to obtain advice for any particular legal matter. 
    //   No reader, user, or browser of this site should act or refrain from acting based on information on this site 
    //   without first seeking legal advice from counsel in the relevant jurisdiction. Only your attorney can provide 
    //   assurances that the information contained herein – and your interpretation of it – is applicable or appropriate 
    //   to your particular situation. Use of and access to this website or any links or resources within this site do 
    //   not create an attorney-client relationship between the reader, user, or browser and website authors, contributors, 
    //   contributing law firms, and their respective employers.
    //   </p>
    //   <p class="disclaimer-text fw-normal">
    //   The views expressed at or through this site are those of the authors writing in their individual capacities only – not this site. 
    //   All liability for actions taken or not taken based on the contents of this site are expressly disclaimed. 
    //   The content on this posting is provided “as is;” no representations are made that the content is error-free.
    //   </p>
    // `;

    const disclaimerObj = document.createElement( 'div' );
    // disclaimerObj.innerHTML = disclaimerHtml;

    /**
     * Call To Action Content
     */
    const actionBoxHtml = getActionBoxHtml();

    const actionBoxObj = document.createElement( 'div' );
    actionBoxObj.innerHTML = actionBoxHtml;

    // create blog content obj
    var contentObj = document.createElement( 'div' );
    contentObj.innerHTML = content;
    
    // Do not remove this tag, but set hidden
    var abposts = contentObj.getElementsByClassName('abpost-category');
    for (const a of abposts) {
      a.style.display = "none"
    }

    // insert call to action box
    var hasDivCTA = false;
    var divCTAs = contentObj.getElementsByClassName('contact-us-holder');
    for (let i=1; i < divCTAs.length; i++) {
      // const divCTA of divCTAs
      const divCTA = divCTAs[i];
      divCTA.innerHTML = actionBoxHtml;
      hasDivCTA = true;
    }

    // update h2-h3 content text
    var h2Tags = contentObj.getElementsByTagName('h2');
    for(const h2 of h2Tags) {
      h2.innerHTML = h2.innerText || h2.textContent;
    }

    var h3Tags = contentObj.getElementsByTagName('h3');
    for(const h3 of h3Tags) {
      h3.innerHTML = h3.innerText || h3.textContent;
    }

    /**
     * Center img
     */
    var pTags = contentObj.getElementsByTagName('p');
    // for (const p of pTags) {
    //   if( p.getElementsByTagName('img').length > 0) {
    //     // there is an image
    //     p.classList.add("text-center");
    //     // break;
    //   }
    // }

    // No DIV CTA Tag
    // Insert before the last p tag
    if (!hasDivCTA && pTags && pTags.length) {
      const lastP = pTags[pTags.length - 1];
      const parentDiv = lastP.parentNode;
      parentDiv.insertBefore(actionBoxObj, lastP);
    }
    
    /**
     * Add Disclaimer
     */
    contentObj.appendChild(disclaimerObj);

    /**
     * 
     */
    const gatsbyImgObjs = contentObj.getElementsByClassName('gatsby-image-wrapper');
    for (const gatsbyImgObj of  gatsbyImgObjs) {
      // get img src set
      const imgs = gatsbyImgObj.getElementsByTagName('img');
      const imgValue = (imgs && imgs.length > 1 ? imgs[1].dataset.src : null);

      // assign img
      if (imgValue) {
        imgs[0].src = imgValue;
      }
      // set first div to 100% max-width
      const subDivs = gatsbyImgObj.getElementsByTagName('div');
      if (subDivs && subDivs.length) {
        const firstDiv = subDivs[0];
        if(firstDiv.getAttribute("style")){
          if(firstDiv.getAttribute("style").indexOf("max-width:") != -1){
              firstDiv.style.maxWidth = "100%";  
          }
        }
      }

      // add text-muted to figcaption
      const figcaptions = contentObj.getElementsByTagName('figcaption');
      for (const figcaption of  figcaptions) {
        figcaption.classList.add("text-muted", "small");
      }
    }

    // Check if last child is not a div with class "contact-us-holder"
    var lastChild = contentObj.lastElementChild;
    if (lastChild) {
      if (lastChild.classList && !lastChild.classList.contains("contact-us-holder")) {
        // If not, append the action box
        contentObj.appendChild(actionBoxObj);
      }
    }
 
    //
    return contentObj.innerHTML;
}